import { DocumentViewerController } from './document-viewer.controller';
import { DocumentViewerProps } from './document-viewer.model';

export const DocumentViewer = (props: DocumentViewerProps) => {
  return <DocumentViewerController {...props} />;
};
